import React, { useState, useEffect } from "react";
import Spinner from "../element/BePatient";
import Footer from "../components/Footer";
import PopUp from "../components/Popup";
import { RiArrowLeftSLine } from "react-icons/ri";
// import { Rating } from "react-simple-star-rating";
import LoggedNav from "../components/LoggedNav";

import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Nav from "../components/Nav";
import profile from "../images/Vector.jpg";
import Rating from '@mui/material/Rating';
import toast from 'react-hot-toast';

function BrowseChef(props) {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [planstatus, setPlanStatus] = useState();
  const [currentPlan, SetPlanData] = useState([]);


  console.log(props);
  let navigate = useNavigate();
  let chefid = localStorage.getItem("chef_id");



  let getUserPlans=async()=>{


    if(localStorage.getItem("logged_user_id")){
      try {
        let response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/subscription/check_current_plan`,
          {
            method: "POST",
       headers: {
              "Authorization": "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
             body: JSON.stringify({
              "user_id":`${localStorage.getItem("logged_user_id")}`,   
              "postal_code": `${localStorage.getItem("postalCode")}`                
             })
                                          
          }
        );
        let responseData = await response.json();
       if(responseData.status){
        console.log(responseData.plan_name);
        setPlanStatus(responseData.plan_status);
      }else{
        toast.error("Sorry unable to fetch")
       }
  
      } catch (error) {
        console.error("Error fetching subscription data:", error);
  }
      }else{
        try {
          let response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/subscription/fetch_plan_details`,
            {
              method: "POST",
         headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
               body: JSON.stringify({
                plan_id:`${localStorage.getItem("plan_id")}`,                   
               })
                                            
            }
          );
          let responseData = await response.json();
         if(responseData.status){
          console.log(responseData.plan_name);
          setPlanStatus(responseData.plan_status);
        }else{
          toast.error("Sorry unable to fetch")
         }
    
        } catch (error) {
          console.error("Error fetching subscription data:", error);
    }
      }
}


  useEffect(() => {
    updateChefs(chefid);

    var title = `Chef Details | CHEF REPUBLIC`;
    var desc = "Browse and select Private Chefs based on the date of service and preferred cuisine/diet selected";
    const titleTag = document.querySelector('title');
    titleTag.innerText = title;
    const metaTitle = document.querySelector("meta[name='title']");
    metaTitle.setAttribute('content', title);
    const metaDescription = document.querySelector("meta[name='description']");
    metaDescription.setAttribute('content', desc);
    const metaTitleOG = document.querySelector("meta[property='og:title']");
    metaTitleOG.setAttribute('content', title);
    const metaDescriptionOG = document.querySelector("meta[property='og:description']");
    metaDescriptionOG.setAttribute('content', desc);
    const metaTitleTwitter = document.querySelector("meta[property='twitter:title']");
    metaTitleTwitter.setAttribute('content', title);
    const metaDescriptionTwitter = document.querySelector("meta[property='twitter:description']");
    metaDescriptionTwitter.setAttribute('content', desc);
    getUserPlans();
    checksubcription();
    // eslint-disable-next-line
  }, []);
  const updateChefs = async (chef_id) => {
    setLoading(true);
    let data = await fetch(
      `${process.env.REACT_APP_BASE_URL}user/guest_get_chef_detail`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chef_id: chef_id.toString(),
        }),
      }
    );
    if (data.status === 500) {
      navigate("/sign-in");
    }
    let parsedData = await data.json();
    setDetails(parsedData.data);
    var title = `${parsedData.data ? parsedData.data[0].chef_name : ""} - Chef Details | CHEF REPUBLIC`;
    const titleTag = document.querySelector('title');
    titleTag.innerText = title;
    const metaTitle = document.querySelector("meta[name='title']");
    metaTitle.setAttribute('content', title);
    setLoading(false);
  };
  function navigateToDetail(chef_id) {
    localStorage.setItem("chef_id", chef_id);
    navigate("/booking-detail");
  }

  function navigateToSubscribe(chef_id) {
    localStorage.setItem("chef_id", chef_id);
    navigate("/subscription-detail", {
      state: {
        option:props?.option ??null ,
    },
  })
  }
  const checksubcription = async () => {
    try {
      let response = await fetch(
        `${process.env.REACT_APP_BASE_URL}subscription/check_current_plan`,
        {
          method: 'POST',
          headers: {
            "Authorization": "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            "user_id": `${localStorage.getItem("logged_user_id")}`,
              "postal_code": `${localStorage.getItem("postalCode")}`
          })
        }
      );
  
     
      const res_json = await response.text();
      const CurrentPlan = JSON.parse(res_json);
  
      if (CurrentPlan.status === true) {
        console.log(CurrentPlan);
        SetPlanData(CurrentPlan);
      } else {
        console.error('Error: Response status is false');
      }
    } catch (error) {
      console.error('Error while fetching data, please try later:', error);
    }
  };



  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>

        
{localStorage.getItem("token") ?
            <LoggedNav customer={props.customer} main={true} /> :
            <Nav customer={props.customer} />
          }
          {/* <Nav customer={props.customer} /> */}
          <div className="container mt-5 ">
            <nav aria-label="breadcrumb">
            <a
            href={currentPlan.chef_status ? `/subscription-summary` : '/chef-list'}
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: 500,
                }}
              >
                <RiArrowLeftSLine size={"2.3rem"} />{" "}
                <span
                  style={{
                    textDecoration: "none",
                    color: "orange",
                    fontWeight: 700,
                  }}
                >
{currentPlan.chef_status ? `Subscription Summary ` : 'Browse Chef'}
                {" "}
                </span>
              </a>
              / {details[0].chef_name}
            </nav>

            <div
              className="main_container row"
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                flexWrap: "wrap",
                width: "100%",
                height: "auto",
              }}
            >
              <div
                className="col-4 prof"
              >
                <OwlCarousel items={1} center={true} mouseDrag={true} touchDrag={true} autoplay={true} autoplayHoverPause={true} dotsEach={true} className="owl-theme my-4" loop>
                  <div className="d-flex justify-content-center align-items-center"><img
                    key={-1}
                    alt=""
                    className="image_box"
                    src={details[0].chef_profile_image}
                    style={{
                      maxHeight: "300px", width: "auto", maxWidth: "100%",
                      borderRadius: "20px",
                      marginTop: "20px",
                    }}
                  />
                  </div>
                  {details[0].chef_images ? details[0].chef_images.map((element, index) => {
                    return <div className="d-flex justify-content-center align-items-center" key={index}><img
                      key={index}
                      alt=""
                      className="image_box"
                      src={element}
                      style={{
                        maxHeight: "300px", width: "auto", maxWidth: "100%",
                        borderRadius: "20px",
                        marginTop: "20px",
                      }}
                    /></div>;
                  }) : null}
                </OwlCarousel>

                <div className="edit_btn mt-4">

                  <button

                  
                    onClick={() => {   planstatus  ?  navigateToSubscribe(details[0].chef_id):    navigateToDetail(details[0].chef_id);}}
                    className="btn btn-orange rounded-pill mb-3 "
                    style={{ width: "90%" }}
                  >
                                {planstatus  ? 'Select' : 'Reserve Chef'}

                  </button>
                </div>
              </div>

              <div
                className="col-8"
              >
                <div className="box_title">
                  <h1 className="">{details[0].chef_name}, {details[0].chef_sex}</h1>
                  <h5 style={{ marginTop: "15px" }}>{details[0].chef_city}</h5>
                </div>

                <div className="d-flex justify-content-start pt-3 mt-3">
                  {/* <Rating
                    allowFraction={true}
                    initialValue={details[0].chef_rating}
                    size={18}
                    allowHover={false}
                    readonly={true}
                    style={{ display: "flex", alignItems: "center" }}
                  /> */}
                  <Rating name="half-rating-read" defaultValue={Number(details[0].chef_rating)} precision={0.5} readOnly />

                  <div className="d-flex justify-content-center ms-3">
                    <p style={{ fontSize: "0.9rem", color: "#7C7C7C" }}>
                      {details[0].chef_total_number_of_reviews} reviews
                    </p>
                  </div>
                </div>

                <hr />

                <div className="message_box my-2 py-2">
                  <h5 style={{ fontWeight: 700 }}>I can cook</h5>
                  <p className="mt-2">{details[0].chef_categories.replaceAll(",", ", ")}</p>
                </div>
                <button
                  type="button"
                  className="btn-orange"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                >
                  View my menu
                </button>
                <PopUp chef_name={details[0].chef_name} rich_text_menu={details[0].rich_text_menu} pdf={details[0].chef_menu} />
                <hr />

                <div className="message_box my-2 py-2 ">
                  <h5 className="my-2 pb-2" style={{ fontWeight: 700 }}>My Availability</h5>
                  <div className="row">
                    {details[0].chef_availability && details[0].chef_availability.monday.length > 0 ? <div className="col-6 row my-1">
                      <p style={{ fontSize: "0.9rem", fontWeight: 700 }} className="col-3">Mon:</p>
                      <p style={{ fontSize: "0.9rem" }} className="col-9 p-0">{details[0].chef_availability.monday.join("; ")}</p>
                    </div> : null}
                    {details[0].chef_availability && details[0].chef_availability.tuesday.length > 0 ? <div className="col-6 row my-1">
                      <p style={{ fontSize: "0.9rem", fontWeight: 700 }} className="col-3">Tue:</p>
                      <p style={{ fontSize: "0.9rem" }} className="col-9 p-0">{details[0].chef_availability.tuesday.join("; ")}</p>
                    </div> : null}
                    {details[0].chef_availability && details[0].chef_availability.wednesday.length > 0 ? <div className="col-6 row my-1">
                      <p style={{ fontSize: "0.9rem", fontWeight: 700 }} className="col-3">Wed:</p>
                      <p style={{ fontSize: "0.9rem" }} className="col-9 p-0">{details[0].chef_availability.wednesday.join("; ")}</p>
                    </div> : null}
                    {details[0].chef_availability && details[0].chef_availability.thursday.length > 0 ? <div className="col-6 row my-1">
                      <p style={{ fontSize: "0.9rem", fontWeight: 700 }} className="col-3">Thu:</p>
                      <p style={{ fontSize: "0.9rem" }} className="col-9 p-0">{details[0].chef_availability.thursday.join("; ")}</p>
                    </div> : null}
                    {details[0].chef_availability && details[0].chef_availability.friday.length > 0 ? <div className="col-6 row my-1">
                      <p style={{ fontSize: "0.9rem", fontWeight: 700 }} className="col-3">Fri:</p>
                      <p style={{ fontSize: "0.9rem" }} className="col-9 p-0">{details[0].chef_availability.friday.join("; ")}</p>
                    </div> : null}
                    {details[0].chef_availability && details[0].chef_availability.saturday.length > 0 ? <div className="col-6 row my-1">
                      <p style={{ fontSize: "0.9rem", fontWeight: 700 }} className="col-3">Sat:</p>
                      <p style={{ fontSize: "0.9rem" }} className="col-9 p-0">{details[0].chef_availability.saturday.join("; ")}</p>
                    </div> : null}
                    {details[0].chef_availability && details[0].chef_availability.sunday.length > 0 ? <div className="col-6 row my-1">
                      <p style={{ fontSize: "0.9rem", fontWeight: 700 }} className="col-3">Sun:</p>
                      <p style={{ fontSize: "0.9rem" }} className="col-9 p-0">{details[0].chef_availability.sunday.join("; ")}</p>
                    </div> : null}
                  </div>
                </div>

                <hr />

                <div className="message_box my-4 ">
                  <h5 className="my-2 py-2" style={{ fontWeight: 700 }}>
                    About me
                  </h5>
                  <p className="my-2">{details[0].chef_description}</p>
                </div>

                <hr />

                <div className="message_box my-4">
                  <h5 className="my-2" style={{ fontWeight: 700 }}>
                    Client Reviews
                  </h5>
                  {details[0].chef_reviews && details[0].chef_reviews.length > 0 ? <OwlCarousel items={1} mouseDrag={true} touchDrag={true} autoplay={true} autoplayHoverPause={true} dotsEach={true} className="owl-theme my-4" loop>
                    {details[0].chef_reviews.map((element, index) => {
                      // console.log(element);
                      return <div className="item" key={index}>

                        {/* <Rating
                          onPointerMove={() => { }}
                          allowFraction={true}
                          initialValue={element.rating}
                          size={24}
                          allowHover={false}
                          readonly={true}
                          style={{ display: "flex", margin: "10px 0", alignItems: "center" }}
                        /> */}

                        <Rating name="half-rating-read" defaultValue={Number(element.rating)} precision={0.5} readOnly />
                        <p className="mt-2 text-wrap text-break" style={{ fontSize: "0.9rem" }}>{element.review_content}</p>
                        <div className="d-flex justify-content-start align-items-center">
                          <div className="ratings text-warning h4 my-3">
                            <img src={element.user_image ? element.user_image : profile} className="rounded-pill" style={{ width: "35px", height: "35px" }} alt="" />
                          </div>
                          <p className="review-count" style={{ marginLeft: "15px", marginBottom: "1px", fontSize: "0.9rem" }}>{element.reviewed_by}</p>
                        </div>
                      </div>;
                    })}
                  </OwlCarousel> : <p className="my-2 text-justify">No Review Yet</p>}
                </div>
              </div>
            </div>
          </div>
          <Footer top={1} />
        </>
      )
      }
    </>
  );
}

export default BrowseChef;
